import Vue from 'vue'
import VueRouter from 'vue-router'
import authenticateRoutes from '@/router/authenticate-routes'
import authenticatedRoutes from '@/router/authenticated-routes'
import publicRoutes from '@/router/public-routes'
import store from '@/store'

import { getAccessToken, setToken } from '@/services/axios'

Vue.use(VueRouter)
Vue.prototype.$store = store

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...publicRoutes,
    ...authenticateRoutes,
    ...authenticatedRoutes,
    {
      path: '/*',
      name: 'NotFound',
      component: () => import('@/views/404/Error404.vue'),
    },
  ],
})

let configGame = Vue.prototype.$store.state.configAccount
const hasMeta = (to, name) => to.meta[name]

store.watch(
  () => Vue.prototype.$store.state.configAccount,
  (newValue, oldValue) => {
    configGame = newValue

    if (hasMeta(router.currentRoute, 'enableLoto') && !configGame.gameConfigs['loto-hotpicks'].enabled) {
      router.push({ name: 'Home' })
      return
    }

    if (hasMeta(router.currentRoute, 'enableLotovert') && !configGame.gameConfigs['loto-vert-hotpicks'].enabled) {
      router.push({ name: 'Home' })
      return
    }

    if (hasMeta(router.currentRoute, 'enableLotoPlus') && !configGame.gameConfigs['loto-plus-hotpicks'].enabled) {
      router.push({ name: 'Home' })
      return
    }

    // redirect checkout when disabled three games
    const enableCheckout = !configGame.gameConfigs['loto-hotpicks'].enabled && !configGame.gameConfigs['loto-vert-hotpicks'].enabled && !configGame.gameConfigs['loto-plus-hotpicks'].enabled
    if (hasMeta(router.currentRoute, 'enableCheckout') && enableCheckout) {
      router.push({ name: 'Home' })
      return
    }
  },
  { deep: true }
)

router.beforeEach((to, from, next) => {
  const langSearchParams: any = to.query?.lang || null

  const token = getAccessToken()

  if (langSearchParams) {
    localStorage.setItem('locale', langSearchParams)
  }

  window.scrollTo({ top: 0 })

  if (hasMeta(to, 'authenticated') && token == null) {
    next({ name: 'Login' })
    return
  }

  if (hasMeta(to, 'guest') && token != null) {
    next({ name: 'Home' })
    return
  }

  next()
})

export default router
